"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskEntityData = void 0;
const react_1 = require("react");
const use_query_params_1 = require("use-query-params");
const core_ui_1 = require("@sierralabs/core-ui");
const entity_ui_1 = require("@sierralabs/entity-ui");
const TaskEvent_1 = require("../interfaces/TaskEvent");
const Task_event_1 = require("../Task.event");
const useFindTask_1 = require("./useFindTask");
// common functionality to fetch task and entityData for workflow enabled entities
function useTaskEntityData(idOrTable, entityDataId) {
    const [version, setVersion] = (0, use_query_params_1.useQueryParam)('version', (0, use_query_params_1.withDefault)(use_query_params_1.NumberParam, undefined));
    const { entityData: foundEntityData, getEntityDataById: apiGetEntityDataById } = (0, entity_ui_1.useFindEntityDataById)(idOrTable, entityDataId, version);
    const [entityData, setEntityData] = (0, react_1.useState)(foundEntityData);
    const taskId = (entityData === null || entityData === void 0 ? void 0 : entityData.taskId) || 0;
    const { task: foundTask, findTask: apiFindTask } = (0, useFindTask_1.useFindTask)(taskId, version);
    const [task, setTask] = (0, react_1.useState)(foundTask);
    const isLatest = !task || !version || version === task.version;
    const findTask = (0, react_1.useCallback)(params => taskId && apiFindTask(params), [taskId, apiFindTask]);
    // get entityData to get taskId
    const getEntityDataById = (0, react_1.useCallback)(params => {
        entityDataId && idOrTable && apiGetEntityDataById(params);
    }, [entityDataId, idOrTable, apiGetEntityDataById]);
    const compareTaskId = (0, react_1.useCallback)((id) => !!(id && taskId === id), [taskId]);
    (0, react_1.useEffect)(() => {
        getEntityDataById();
    }, [getEntityDataById]);
    (0, react_1.useEffect)(() => {
        findTask();
    }, [findTask]);
    (0, react_1.useEffect)(() => {
        foundTask && setTask(foundTask);
    }, [foundTask]);
    (0, react_1.useEffect)(() => {
        foundEntityData && setEntityData(foundEntityData);
    }, [foundEntityData]);
    // update status on transition to update disabled fields
    (0, react_1.useEffect)(() => {
        return Task_event_1.TaskEvent.handle(Task_event_1.TaskEventType.ChangeStatus, data => {
            if (data && compareTaskId(data.task.id)) {
                setTask(data.task);
            }
        });
    }, [compareTaskId]);
    // refetch entityData when form gets updated
    (0, react_1.useEffect)(() => {
        return core_ui_1.CoreEvent.handle(TaskEvent_1.TaskEntityDataEvent.Update, data => {
            const updatedEntityData = data === null || data === void 0 ? void 0 : data.entityData;
            const taskId = (data === null || data === void 0 ? void 0 : data.taskId) || (updatedEntityData === null || updatedEntityData === void 0 ? void 0 : updatedEntityData.taskId);
            if (updatedEntityData && compareTaskId(taskId)) {
                setEntityData(entityData => {
                    return Object.assign(Object.assign({}, entityData), updatedEntityData);
                });
            }
        });
    }, [compareTaskId]);
    return {
        task,
        taskId,
        entityData,
        version,
        isLatest,
        findTask,
        getEntityDataById,
        setEntityData,
        setTask,
        setVersion
    };
}
exports.useTaskEntityData = useTaskEntityData;
//# sourceMappingURL=useTaskEntityData.js.map